module.exports = __webpack_public_path__ + "assets/a527e9159b82b48889402877c32927bf.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/DASS/DASS02.mp3
 ** module id = 211
 ** module chunks = 0
 **/